export const SITE_NAME = "Connie's Cakerie";
export const SITE_URL = "https://www.conniescakerie.com";
export const BAKERY_ID = `${SITE_URL}/#bakery`;
export const IG_URL = "https://www.instagram.com/conniescakerie";
export const FB_URL = "https://www.facebook.com/conniescakerie";
export const CURR_YEAR = new Date().getFullYear();

/** Flip to true when the Services section is ready to publish. */
export const SERVICES_ENABLED = false;

/** Visible through Sept 26, 2026 (America/Los_Angeles); hidden from Sept 27 onward. */
export const PROMO_BANNER_EXPIRES_AT = new Date("2026-09-27T00:00:00-07:00");
export const PROMO_BANNER_RSVP_URL = "https://square.link/u/nfth2rYq";

export function isPromoBannerVisible(now = new Date()) {
  return now < PROMO_BANNER_EXPIRES_AT;
}

export function isServicesPath(pathname: string) {
  return pathname === "/services" || pathname.startsWith("/services/");
}